import EmojiShadowBox from "@/components/common/EmojiShadowBox";
import { Box } from "@chakra-ui/react";

import { matchHeadFontCss } from "containers/MatchContainer/MatchContainer";
import { colors, getCdnImageSrc, Image, useResponsive, VStack } from "goi_common";
import React from "react";

export default function ExplanationSection() {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack
      position="relative"
      width="100%"
      height="100%"
      padding={isBiggerThanLg ? "100px 0px 0px" : "60px 0px 0px"}
      alignItems="center"
      background={colors.warmGray100}
    >
      <VStack alignItems="center" width="100%" css={matchHeadFontCss}>
        <div css={{ textAlign: "center" }}>
          제대로 된 장례 전문가,
          <br />
          일일이 찾기 어려우셨죠?
        </div>
      </VStack>
      <Box
        display="flex"
        flexDirection={isBiggerThanLg ? "row" : "column"}
        gap={isBiggerThanLg ? "14px" : "12px"}
        width={isBiggerThanLg ? "800px" : "100%"}
        alignItems="center"
        padding="26px 0px"
        flexWrap="wrap"
        css={{ alignItems: "center", justifyContent: "center" }}
      >
        <EmojiShadowBox
          emoji={
            <Image
              src={getCdnImageSrc("platform/notice/sad-but-relieved-face-emoji.png")}
              alt=""
              width="100%"
              height="100%"
            />
          }
          text="비용은 저렴하지만 불안해요"
        />
        <EmojiShadowBox
          emoji={
            <Image
              src={getCdnImageSrc("platform/notice/pensive-face-emoji.png")}
              alt=""
              width="100%"
              height="100%"
            />
          }
          text="회사가 너무 많고 광고글밖에 없어요"
        />
        <EmojiShadowBox
          emoji={
            <Image
              src={getCdnImageSrc("platform/notice/face-with-monocle-emoji.png")}
              alt=""
              width="100%"
              height="100%"
            />
          }
          text="믿을만하고 정성껏 모셔주는 곳 없나요?"
        />

        <EmojiShadowBox
          emoji={
            <Image
              src={getCdnImageSrc("platform/notice/thinking-face-emoji.png")}
              alt=""
              width="100%"
              height="100%"
            />
          }
          text="어떤 기준으로 비교할지 모르겠어요"
        />
      </Box>
      <VStack
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 1) 100%)"
        zIndex={3}
        css={{ bottom: 0 }}
      ></VStack>
      <VStack position="relative" alignItems="center" width="100%">
        <Image
          src={getCdnImageSrc("platform/notice/computer-sangju.png")}
          width="171px"
          css={{ zIndex: 4, paddingBottom: "14px" }}
          alt=""
        />
      </VStack>
    </VStack>
  );
}
